"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import * as React from "react";

import { SVGIcon } from "../SVGIcon";
import { createSVGIcon } from "../util";

const VIEWBOX = "0 0 140 140";

/**
 * @deprecated use Star from foundation/Star
 * @trackcomponent
 * SVG purchased from: https://app.streamlineicons.com/streamline-mini-line/interface-essential/bookmark-favorite/interface-favorite-star
 * @optimized using svgo:^3.0.2
 */
export const Star = createSVGIcon(
  <path
    d="M7.492 1.091 9.075 4.3a.55.55 0 0 0 .413.3l3.542.516a.548.548 0 0 1 .3.935l-2.564 2.5a.55.55 0 0 0-.157.485l.605 3.532a.548.548 0 0 1-.8.577l-3.159-1.661a.55.55 0 0 0-.51 0L3.578 13.15a.548.548 0 0 1-.8-.577l.605-3.532a.55.55 0 0 0-.157-.485L.666 6.054a.548.548 0 0 1 .3-.935L4.512 4.6a.55.55 0 0 0 .413-.3l1.583-3.209a.549.549 0 0 1 .984 0Z"
    fill="transparent"
    stroke="currentColor"
    transform="scale(10)"
  />,
  "Star",
  { viewBox: VIEWBOX, width: "24", height: "24", className: legacyIconCls() }
);

/**
 * @deprecated use Star from foundation/Star with fill=black
 * @trackcomponent
 * SVG purchased from: https://app.streamlineicons.com/streamline-mini-line/interface-essential/bookmark-favorite/interface-favorite-star
 * @optimized using svgo:^3.0.2
 */
export const StarSolid = createSVGIcon(
  <path
    d="M7.492 1.091 9.075 4.3a.55.55 0 0 0 .413.3l3.542.516a.548.548 0 0 1 .3.935l-2.564 2.5a.55.55 0 0 0-.157.485l.605 3.532a.548.548 0 0 1-.8.577l-3.159-1.661a.55.55 0 0 0-.51 0L3.578 13.15a.548.548 0 0 1-.8-.577l.605-3.532a.55.55 0 0 0-.157-.485L.666 6.054a.548.548 0 0 1 .3-.935L4.512 4.6a.55.55 0 0 0 .413-.3l1.583-3.209a.549.549 0 0 1 .984 0Z"
    fill="transparent"
    stroke="currentColor"
    transform="scale(10)"
  />,
  "StarSolid",
  { viewBox: VIEWBOX, width: "24", height: "24" }
);

/**
 * Dynamic version of the variants of the star icons.
 * @deprecated use Star from foundation/Star
 * @trackcomponent
 * SVG purchased from: https://app.streamlineicons.com/streamline-mini-line/interface-essential/bookmark-favorite/interface-favorite-star
 */
export const StarDynamic = React.memo(
  ({
    solid = false,
    viewBox = VIEWBOX,
    ref,
    ...props
  }: SVGIcon.IProps & {
    solid?: boolean;
  } & React.RefAttributes<SVGElement>) => (
    <SVGIcon viewBox={viewBox} ref={ref} {...props}>
      <g transform="matrix(10,0,0,10,0,0)">
        <path
          d="M7.492,1.091,9.075,4.3a.55.55,0,0,0,.413.3l3.542.516a.548.548,0,0,1,.3.935l-2.564,2.5a.546.546,0,0,0-.157.485l.605,3.532a.548.548,0,0,1-.8.577L7.255,11.484a.548.548,0,0,0-.51,0L3.578,13.15a.548.548,0,0,1-.8-.577l.605-3.532a.546.546,0,0,0-.157-.485L.666,6.054a.548.548,0,0,1,.3-.935L4.512,4.6a.55.55,0,0,0,.413-.3L6.508,1.091A.549.549,0,0,1,7.492,1.091Z"
          fill={solid ? "currentColor" : "transparent"}
          stroke="currentColor"
        />
      </g>
    </SVGIcon>
  )
);
if (process.env.NODE_ENV !== "production") {
  StarDynamic.displayName = "StarIcon";
}
